import { UI, Stack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  ColorCodedText,
  ColorCodedTextProps,
} from '../../../../../../../../../components/ColorCodedText';
import { OperationType } from '../../../../../../../../../components/OperationType';

export interface AssetItemProps {
  rows: number;
  columns: number;
  label: string;
  value?: string;
  isLoading: boolean;
  coloredBySign?: ColorCodedTextProps['sign'];
  highlighted?: boolean;
}

export const AssetItem: React.FC<AssetItemProps> = ({
  columns,
  rows,
  label,
  coloredBySign,
  isLoading,
  value = '',
  highlighted,
}) => {
  const renderValue = () => {
    if (isLoading) {
      return <UI.Text isLoading fontSize={Typography['fontsize.md']} color="neutral.dark" />;
    }
    if (coloredBySign) {
      return <ColorCodedText sign={coloredBySign} text={value} />;
    }
    if (highlighted) {
      return (
        <Stack alignSelf="flex-start">
          <OperationType title={`${value}`} />
        </Stack>
      );
    }
    return <UI.Text color="neutral.dark">{`${value}`}</UI.Text>;
  };

  return (
    <VStack
      justifyContent="space-between"
      alignContent="center"
      space={Spacing['inline.quarck']}
      w={rows !== 1 ? `${100 / columns}%` : undefined}>
      <UI.Text fontSize={Typography['fontsize.md']} variant="semibold">
        {label}
      </UI.Text>
      {renderValue()}
    </VStack>
  );
};
